module.exports = __webpack_public_path__ + "img/mad.9ab4f772.svg";